import { useEffect, useState } from 'react'

export const use2D3DViewSwitch = () => {
  const [viewType, setViewType] = useState('2D')

  useEffect(() => {
    localStorage.setItem('viewType', viewType)
  }, [viewType])

  return [viewType, setViewType]
}
